import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import jwt_decode from "jwt-decode";
import {ContractService} from "../../lib/services/contracts/contract.service";
import {TokenExpiredTimerService} from "../../lib/services/token-expired-timer/token-expired-timer.service";
import {StorageKeysEnum} from "../../lib/storage/storage-keys.enum";
import {UserUtilsService} from '../../lib/services/user/user-utils.service';
import {GeolocationService} from '../../lib/services/geolocation/geolocation.service';
import {firstValueFrom, Subscription} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {InactivityService} from "../../lib/services/inactivity/inactivity.service";
import {ToastService} from '../../lib/services/toast/toast.service';
import {HttpHeaders} from '@angular/common/http';
import {AuthenticationService} from '../../lib/services/autenticacion/authentication.service';
import {TokenUnlockService} from '../../lib/services/token-unlock/token-unlock.service';
import * as pubsub from "pubsub-js"
import {UserBlockedService} from '../../lib/services/user-blocked/user-blocked-service.service';
import {LoadingService} from "../../lib/services/loading/loading.service";
import {RedirectService} from "../../lib/services/redirect/redirect.service";

@Component({
    selector: 'app-geolocation',
    templateUrl: './geolocation.component.html',
    styleUrls: ['./geolocation.component.scss']
})
export class GeolocationComponent implements OnInit, OnDestroy {

    showInit: boolean = false;
    showLogin: boolean = false;
    showValidateToken: boolean = false;
    showGeolocalization: boolean = true;
    showAuth07Error: boolean = false
    showWebAlreadySession: boolean = false
    loadingLocation: boolean = false;
    loadingSendingEmail: boolean = false
    attemptsAllowed: boolean = false;
    params: any;
    subscriptions: Subscription[] = []
    authCloseSessionHeader: HttpHeaders = new HttpHeaders()
    translations: any
    validatingRedirect = true;

    @Output() validateGeolocation: EventEmitter<any> = new EventEmitter<any>();

    constructor(private router: Router,
                private activeRoute: ActivatedRoute,
                private contractService: ContractService,
                private tokenExpiredTimerService: TokenExpiredTimerService,
                private userUtilsService: UserUtilsService,
                private geo: GeolocationService,
                private translate: TranslateService,
                private inactivityService: InactivityService,
                private toastService: ToastService,
                private authService: AuthenticationService,
                private tokenUnlockModal: TokenUnlockService,
                private userBlockedService: UserBlockedService,
                private loadingService: LoadingService,
                private redirectService: RedirectService
    ) {
    }

    async ngOnInit(): Promise<void> {
        await this.isRedirect()
        await this.preloadTranslations()
        pubsub.subscribe("closeGenericModal", (msg: any, data: any) => {
            location.reload()
        })
        const sub = this.activeRoute.queryParams
            .subscribe(params => {
                if (params["login"] != null) {
                    this.showLogin = true;
                    this.showGeolocalization = false;
                }
            });
        this.subscriptions.push(sub)
        this.params = this.activeRoute.snapshot.queryParams;
        this.validateGeo();
        this.loadingService.show();
    }

    async isRedirect() {
        try {
            await this.redirectService.isRedirect();
            this.validatingRedirect = false;
        } catch (e) {
            this.validatingRedirect = false;
            return
        }
    }

    changeShow($event: MouseEvent) {
        this.showInit = !this.showInit;
        this.showAuth07Error = false
    }

    async validateGeo()
    {
        if (navigator.geolocation) {
            this.loadingLocation = true

            // Define options with timeout (in milliseconds)
            const options = {
                timeout: 10000, // 10 seconds timeout
                enableHighAccuracy: true,
                maximumAge: 0,
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const cords = {
                        lat: position.coords.latitude,
                        lon: position.coords.longitude,
                    }
                    sessionStorage.setItem(StorageKeysEnum.COORDS, JSON.stringify(cords))
                    if (this.params.returnUrl != undefined && sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN) != null) {
                        this.router.navigate([this.params.returnUrl])
                        return
                    } else {
                        this.showLogin = true
                        this.showGeolocalization = false
                        this.loadingLocation = false
                        return
                    }
                },
                async (error) => {
                    this.showLogin = false
                    this.showGeolocalization = true
                    this.loadingLocation = false
                    const p = {
                        p1: await firstValueFrom(this.translate.get("Se le recuerda que")),
                        p2: await firstValueFrom(this.translate.get("de acuerdo con las Disposiciones oficiales vigentes")),
                        p3: await firstValueFrom(
                            this.translate.get(
                                "necesitamos de su consentimiento del uso de la ubicacion de su navegador para poder estar en la Banca Digital",
                            ),
                        ),
                        p4: await firstValueFrom(this.translate.get("La informacion de ubicacion no esta disponible")),
                        p5: await firstValueFrom(this.translate.get("Se agoto el tiempo de espera para obtener la ubicacion")),
                        p6: await firstValueFrom(this.translate.get("Se produjo un error desconocido")),
                        p7: await firstValueFrom(
                            this.translate.get(
                                "Ve a las configuraciones de tu explorador para habilitar la geolocalizacion en nuestra pagina",
                            ),
                        ),
                        p8: await firstValueFrom(this.translate.get("La geolocalizacion no es compatible con este navegador")),
                    }
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            alert(`${p.p1}, ${p.p2}, ${p.p3}.`)
                            this.geo.locationControl = false
                            break
                        case error.POSITION_UNAVAILABLE:
                            alert(`${p.p4}.`)
                            break
                        case error.TIMEOUT:
                            alert(`${p.p5}.`)
                            break
                        default:
                            alert(`${p.p6}.`)
                            break
                    }
                },
                options, // Add the options object here
            )
        } else {
            const p = await firstValueFrom(this.translate.get("La geolocalizacion no es compatible con este navegador"))
            alert(`${p}.`)
            return
        }
    }
    loginSuccess(event: any) {
        if (event?.username === 'intentos') {
            this.attemptsAllowed = true;
            this.showLogin = false;
            this.showValidateToken = false;
            return
        } else {
            this.showLogin = false;
            this.showValidateToken = true;
            return
        }
    }

    validateTokenSuccess() {
        this.inactivityService.startSessionTimer()
        return this.getContracts();
    }

    onAuth07Error(token: string) {
        const parsedToken: { authorizationCloseSession: string } = JSON.parse(token)
        const decodedToken: CloseSessionTokenType = jwt_decode(parsedToken.authorizationCloseSession)

        this.showWebAlreadySession = decodedToken.zona == "ServiciosBancaEnLinea"
        this.showAuth07Error = true
        this.showInit = false
        this.showLogin = false;
        this.authCloseSessionHeader = this.authCloseSessionHeader.set('Authorization-Close-Session', parsedToken.authorizationCloseSession)
        this.authService.setAuthCloseSessionHeaders(this.authCloseSessionHeader)
    }

    redirectToLogin() {
        location.reload()
    }

    async preloadTranslations() {
        this.translations = await firstValueFrom(this.translate.get([
            "USER_BLOCKED_COMP",
            "TOKEN_UNLOCK",
            "TOKEN01",
            "EMAIL_CLOSE_SESSION_ERROR",
            "AUTH_SESSION_03",
            "UNLOCK_SESSION_P3",
            "UNLOCK_SESSION_P2",
            "UNLOCK_SESSION_P1",
            "UNLOCK_SESSION_MODAL_TITLE"
        ]))

        this.userBlockedService.setTranslations(this.translations.USER_BLOCKED_COMP)
    }

    async sendEmailToCloseSession() {
        let res
        this.loadingSendingEmail = true

        try {
            res = await firstValueFrom(this.authService.sendEmailToCloseSession(this.authCloseSessionHeader))
        } catch (error: any) {
            this.loadingSendingEmail = false
            if (error.error.errorCode == "AUTH_SESSION_03") {
                this.toastService.showToast(this.translations["AUTH_SESSION_03"], "error", "Error", "tk")
                return
            }

            if (error.error.errorCode == "TOKEN01") {
                this.toastService.showToast(this.translations["TOKEN01"], "error", "Error", "tk")
                return
            }

            this.toastService.showToast(this.translations["EMAIL_CLOSE_SESSION_ERROR"], "error", "Error", "tk")
            return
        }

        this.loadingSendingEmail = false
        const title = this.translations["UNLOCK_SESSION_MODAL_TITLE"]
        const p = {
            p1: this.translations["UNLOCK_SESSION_P1"],
            p2: this.translations["UNLOCK_SESSION_P2"],
            p3: this.translations["UNLOCK_SESSION_P3"],
        }
        const composition = `<p>${p.p1}, <strong>${p.p2}</strong>. ${p.p3}</p>`
        this.tokenUnlockModal.openExternalUnlockToken(false, {
            title,
            paragraph: composition,
            translations: this.translations.TOKEN_UNLOCK
        }, false)
    }

    getContracts() {
        const tokenString: any = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO);
        const token: any = jwt_decode(tokenString)
        const sub = this.contractService.getContractInformationByUser().subscribe({
            next: async contracts => {
                if (contracts.length <= 0) {
                    const errorMsg = await firstValueFrom(this.translate.get("No hay contratos disponibles"))
                    this.toastService.showToast(errorMsg)
                    return
                }
                const contractInformationString = sessionStorage.getItem(StorageKeysEnum.CONTRACTS_INFORMATION)
                const contractInformation: any = contractInformationString ? JSON.parse(contractInformationString) : {};
                sessionStorage.setItem(StorageKeysEnum.CONTRACTS_INFORMATION, JSON.stringify({
                    ...contractInformation,
                    contractsUser: contracts.datos.isrvContrato.contratos
                }));
                this.userUtilsService.setUserInfoSessionStorage(
                    {
                        name: token.usuario,
                        fullName: contracts?.datos?.nomCompleto,
                        typePerson: contracts?.datos?.cvePersJuridica,
                        contrato: contracts?.datos?.isrvContrato.contratos
                    }
                )
                this.showLogin = false;
                this.showValidateToken = false;
                this.tokenExpiredTimerService.startLogoutTimer()
                this.router.navigate(['/']);
            },
            error: error => {
                this.showLogin = false;
                this.showValidateToken = false;
            }
        })
        this.subscriptions.push(sub)
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(x => x.unsubscribe())
        pubsub.unsubscribe("closeGenericModal")
    }

}


type CloseSessionTokenType = {

    "zona": string, //"ServiciosBancaEnLinea",
    "ubicacion": string,
    "agent": string,
    "usuario": string,
    "closeSession": boolean,
    "exp": number

}
